module.exports = __webpack_public_path__ + "assets/adpoly-facility-academic-offices-bulk-upload-template.b1aeb824.xlsx";